<div class="dialog-container">

  <div class="dialog-header">
    <span class="dialog-title">{{'offer.versionHistory.dialogTitle' | translate}}</span>
    <button class="close-button" mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">

    <div *ngIf="loading" class="d-flex justify-content-center py-4">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <div *ngIf="!loading && errored" class="state-message state-error">
      {{'offer.versionHistory.error' | translate}}
    </div>

    <div *ngIf="!loading && !errored && versions.length === 0" class="state-message state-empty">
      {{'offer.versionHistory.empty' | translate}}
    </div>

    <ng-container *ngIf="!loading && !errored && versions.length > 0">
      <div class="d-flex justify-content-between align-items-center button-container">
        <div class="open-details d-flex align-items-center">
          <span class="open-all-label">
            {{(!allDetailsOpen ? 'createOffer.openDetails' : 'createOffer.closeDetails') | translate}}
          </span>
          <mat-slide-toggle class="ms-2" [(ngModel)]="allDetailsOpen"></mat-slide-toggle>
        </div>
      </div>

      <mat-accordion [multi]="true" displayMode="flat" class="accordion-container outer-accordion">
        <ng-container *ngFor="let item of versions; let last = last; trackBy: trackByVersion">
          <mat-expansion-panel [togglePosition]="'before'" class="version-panel">
            <mat-expansion-panel-header [@.disabled]="true">
              <mat-panel-title>
                <span class="version-title">
                  {{'offer.versionHistory.version' | translate: {number: item.versionNumber} }}
                </span>
              </mat-panel-title>
              <mat-panel-description>
                <span *ngIf="item.rows.length > 0" class="change-count-badge">
                  {{ (item.rows.length === 1
                       ? 'offer.versionHistory.changesCountSingular'
                       : 'offer.versionHistory.changesCountPlural')
                      | translate: {count: item.rows.length} }}
                </span>
                <span *ngIf="item.rows.length === 0 && (!item.entry.changes || item.entry.changes.length === 0)" class="created-badge">
                  {{'offer.versionHistory.created' | translate}}
                </span>
                <span *ngIf="item.rows.length === 0 && item.entry.changes?.length > 0" class="no-changes-badge">
                  {{'offer.versionHistory.noChanges' | translate}}
                </span>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <!-- Change summary block -->
            <div *ngIf="item.rows.length > 0" class="version-changes">
              <div *ngFor="let row of item.rows; trackBy: trackByRow" class="change-row">
                <span class="field-label">{{row.label}}:</span>
                <span class="new-value">{{row.formattedNew}}</span>
                <span class="old-value" *ngIf="row.hasOld">({{row.formattedOld}})</span>
              </div>
            </div>

            <!-- Inner expandable showing the offer at this version -->
            <app-offer-version-details-expandable
              [offer]="item.entry.offer"
              [changes]="item.entry.changes"
              [existingFileIds]="currentFileIds"></app-offer-version-details-expandable>
          </mat-expansion-panel>
          <hr *ngIf="!last">
        </ng-container>
      </mat-accordion>
    </ng-container>

  </div>
</div>
